<script>
import $ from 'jquery';

export default {
  name: 'DateTimeMixin',
  computed: {
    listeners() {
      return this.$listeners;
    },
    rootAttrs() {
      return this.$attrs;
    }
  },
  watch: {
    minDate: 'handleDateValidation',
    maxDate: 'handleDateValidation',
    minTime: 'handleTimeValidation',
    maxTime: 'handleTimeValidation'
  },
  mounted() {
    this.bindClick();
    this.handleDateValidation();
  },
  methods: {
    onChange(e) {
      this.$emit('onChange', e.target.value);
      this.handleDateValidation();
    },
    bindClick() {
      if (/Mobi/.test(navigator.userAgent)) {
      // if mobile device, use native pickers
        $('.date-time input').attr('type', 'datetime-local');
        $('.date input').attr('type', 'date');
        $('.time input').attr('type', 'time');
      } else {
        $(`#${this.id}`).datetimepicker(this.config);
      }
    },
    setValue(value) {
      $(`#${this.id}`).value = value;
    },
    handleDateValidation() {
      if (this.maxDate) {
        $(`#${this.id}`).data('DateTimePicker').maxDate(this.maxDate);
      }
      if (this.minDate) {
        $(`#${this.id}`).data('DateTimePicker').minDate(this.minDate);
      }
    },
    handleTimeValidation() {
      if (this.minTime) {
        $(`#${this.id}`).datetimepicker({
          minTime: this.minTime
        });
      }
      if (this.maxTime) {
        $(`#${this.id}`).datetimepicker({
          maxTime: this.maxTime
        });
      }
    }
  }
};
</script>
